import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { ContactSalesButtonPropsInterface } from 'ui-addon-upgrades/_core/contactSales/ContactSalesPropsInterface';
import { TALK_TO_SALES_FALLBACK, TALK_TO_SALES, PRICING_PAGE_REDIRECT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { getParsedProductPurchaseMotions } from 'ui-addon-upgrades/_core/common/data/purchaseMotionData/getParsedProductPurchaseMotions';
import { TALK_TO_SALES_BUTTON } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { LISTS_LIMIT_INCREASE, WORKFLOWS_LIMIT_INCREASE, ESIGNATURE_LIMIT_INCREASE, CMS_HUB_PROFESSIONAL, CMS_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, MARKETING_HUB_STARTER, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE } from 'self-service-api/constants/ApiNames';
import UIPricingPageRedirectButton from './UIPricingPageRedirectButton';

// A wrapper around UIContactSalesButton that fetches purchase motion info.
// Should only be used for Professional or Enterprise tier products b/c we dont want
// to include the touchless motion in this button
const UIEEConnectedContactSalesButton = props => {
  const [ttsPurchaseMotion, setTtsPurchaseMotion] = useState(null);

  const {
    apiName
  } = props,
        propsToPass = _objectWithoutPropertiesLoose(props, ["apiName"]);

  const isMounted = useRef(true);
  useEffect(() => {
    getParsedProductPurchaseMotions({
      location: TALK_TO_SALES_BUTTON,
      apiName
    }).then(purchaseMotions => {
      // TALK_TO_SALES_BUTTON location only returns one purchase motion
      const purchaseMotion = purchaseMotions && purchaseMotions[0] || TALK_TO_SALES_FALLBACK;

      if (isMounted.current) {
        setTtsPurchaseMotion(purchaseMotion);
      }
    }).catch(() => {
      if (isMounted.current) {
        setTtsPurchaseMotion(TALK_TO_SALES_FALLBACK);
      }
    });
    return function cleanup() {
      isMounted.current = false;
    };
  }, [isMounted, apiName]);
  if (!ttsPurchaseMotion) return null; // A pp redirect motion will only be returned for users in Russia

  if (ttsPurchaseMotion === PRICING_PAGE_REDIRECT) {
    return /*#__PURE__*/_jsx(UIPricingPageRedirectButton, Object.assign({}, propsToPass));
  }

  return /*#__PURE__*/_jsx(UIContactSalesButton, Object.assign({}, propsToPass, {
    isAssignable: ttsPurchaseMotion === TALK_TO_SALES
  }));
};

UIEEConnectedContactSalesButton.propTypes = Object.assign({
  apiName: PropTypes.oneOf([LISTS_LIMIT_INCREASE, WORKFLOWS_LIMIT_INCREASE, ESIGNATURE_LIMIT_INCREASE, CMS_HUB_PROFESSIONAL, CMS_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, MARKETING_HUB_STARTER, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE]).isRequired
}, upgradeDataPropsInterface, {}, ContactSalesButtonPropsInterface);
export default UIEEConnectedContactSalesButton;